module.exports = __webpack_public_path__ + "img/join now new discord.a877956b.png";